(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mocolune-pair-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mocolune-pair-builder')) {
    class MocolunePairBuilder extends HTMLElement {
      // All instances on this document share a lock. This is not a server idempotency key.
      static busy = false;
      static attempted = false;

      connectedCallback() {
        if (this.initialized) return;
        this.form = this.querySelector('[data-builder-form]');
        if (!this.form) return;
        this.initialized = true;
        this.button = this.querySelector('[data-submit]');
        this.message = this.querySelector('[data-message]');
        this.result = this.querySelector('[data-result]');
        this.cartLink = this.querySelector('[data-cart-link]');
        try {
          const rawRoot = window.Shopify?.routes?.root || this.dataset.root || '/';
          this.root = new URL(rawRoot.endsWith('/') ? rawRoot : rawRoot + '/', location.origin);
          this.cartURL = new URL(this.dataset.cartUrl, location.origin);
          if (this.root.origin !== location.origin || this.cartURL.origin !== location.origin) throw new Error('Invalid route');
          this.cards = Array.from(this.querySelectorAll('[data-card]'), card => {
            const product = JSON.parse(card.querySelector('[data-product]').textContent);
            const selectors = Array.from(card.querySelectorAll('[data-option]'));
            const toggle = card.querySelector('[data-include]');
            selectors.forEach(select => { select.value = ''; });
            if (toggle) toggle.checked = false;
            return { card, product, selectors, toggle, fields: card.querySelector('[data-options]'), price: card.querySelector('[data-price]'), status: card.querySelector('[data-variant-status]'), initialPrice: card.querySelector('[data-price]').textContent };
          });
          this.form.addEventListener('submit', event => this.submit(event));
          this.form.addEventListener('change', () => this.refresh());
          this.refresh();
          if (MocolunePairBuilder.attempted) this.say('Bitte den Warenkorb prüfen, bevor du erneut Artikel hinzufügst.');
        } catch (_) {
          this.say('Die Auswahl konnte nicht geladen werden. Bitte die Produktseiten oder den Warenkorb öffnen.');
        }
      }

      selectedVariant(entry) {
        if (!entry.selectors.length || entry.selectors.some(select => select.value === '')) return null;
        return entry.product.variants.find(variant =>
          variant.options.length === entry.selectors.length &&
          variant.options.every((value, index) => value === entry.selectors[index].value)
        ) || null;
      }

      isSelected(entry) {
        return entry.card.dataset.optional === 'false' || Boolean(entry.toggle?.checked);
      }

      refresh() {
        const locked = MocolunePairBuilder.busy || MocolunePairBuilder.attempted;
        this.button.disabled = locked || !this.cards[0]?.fields;
        this.form.setAttribute('aria-busy', String(MocolunePairBuilder.busy));
        this.cards.forEach(entry => {
          const selected = this.isSelected(entry);
          if (entry.toggle) {
            entry.toggle.disabled = locked;
            entry.toggle.setAttribute('aria-expanded', String(selected));
          }
          if (entry.fields) {
            entry.fields.hidden = !selected;
            entry.fields.disabled = !selected || locked;
          }
          const variant = this.selectedVariant(entry);
          entry.price.textContent = variant ? variant.price : entry.initialPrice.trim();
          if (entry.status) entry.status.textContent = !variant
            ? 'Bitte alle Optionen wählen. Menge: 1.'
            : variant.available && !variant.requiresSellingPlan
              ? 'Ausgewählte Ausführung · Menge: 1.'
              : 'Diese Ausführung ist hier nicht verfügbar. Bitte eine andere wählen.';
        });
      }

      static refreshAll() {
        document.querySelectorAll('mocolune-pair-builder').forEach(builder => {
          if (builder.cards) builder.refresh();
        });
      }

      say(text, focus = false) {
        this.message.textContent = text;
        if (focus) this.message.focus();
      }

      // Timeout does NOT establish whether a POST reached Shopify. Never retry a POST.
      async request(path, options = {}) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(new URL(path, this.root), {
            credentials: 'same-origin', cache: 'no-store', ...options,
            headers: { Accept: 'application/json', ...options.headers }, signal: controller.signal
          });
          let body = null;
          try { body = await response.json(); } catch (_) { /* Keep unknown response explicit. */ }
          return { ok: response.ok, status: response.status, body };
        } finally {
          clearTimeout(timer);
        }
      }

      async readCart() {
        const response = await this.request('cart.js');
        if (!response.ok || !Array.isArray(response.body?.items) ||
          response.body.items.some(item => !Number.isInteger(item.quantity) || item.quantity < 0)) {
          throw new Error('Cart could not be verified');
        }
        return response.body;
      }

      quantity(cart, id) {
        // Unpersonalized one-time-purchase lines only; discount-split lines are summed.
        return cart.items.filter(item => String(item.variant_id ?? item.id) === id &&
          !item.selling_plan_allocation &&
          Object.values(item.properties || {}).every(value => value == null || value === '')
        ).reduce((total, item) => total + item.quantity, 0);
      }

      async submit(event) {
        event.preventDefault();
        // Do not let a theme's delegated submit listener issue a second cart request.
        event.stopImmediatePropagation();
        if (MocolunePairBuilder.busy || MocolunePairBuilder.attempted) return;
        const requested = new Map();
        for (const entry of this.cards.filter(card => this.isSelected(card))) {
          const variant = this.selectedVariant(entry);
          if (!variant || !variant.available || variant.requiresSellingPlan) {
            this.say('Bitte für jeden ausgewählten Artikel eine verfügbare Ausführung wählen.', true);
            entry.selectors.find(select => !select.value)?.focus();
            return;
          }
          const previous = requested.get(variant.id);
          requested.set(variant.id, {
            id: variant.id, quantity: (previous?.quantity || 0) + 1,
            label: entry.product.title + ' · ' + variant.options.join(' / ')
          });
        }
        if (!requested.size) return;

        MocolunePairBuilder.busy = true;
        MocolunePairBuilder.refreshAll();
        this.result.replaceChildren();
        this.result.hidden = true;
        this.say('Dein Warenkorb wird geprüft …');
        let before;
        try {
          before = await this.readCart();
        } catch (_) {
          MocolunePairBuilder.busy = false;
          MocolunePairBuilder.refreshAll();
          this.say('Der Warenkorb ist gerade nicht erreichbar. Es wurde keine Hinzufügung gesendet. Bitte später erneut versuchen.', true);
          return;
        }

        // From this point, manual cart review/navigation is required before another attempt.
        MocolunePairBuilder.attempted = true;
        let added = null;
        try {
          added = await this.request('cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: Array.from(requested.values(), ({ id, quantity }) => ({ id, quantity })) })
          });
        } catch (_) { /* An uncertain POST may still have added items. Read cart next. */ }

        let after = null;
        try { after = await this.readCart(); } catch (_) { /* Never infer an empty cart. */ }
        MocolunePairBuilder.busy = false;
        MocolunePairBuilder.refreshAll();

        const sameCart = after && before.token && after.token === before.token;
        const complete = sameCart && Array.from(requested.values()).every(item =>
          this.quantity(after, item.id) - this.quantity(before, item.id) === item.quantity
        );
        const responseConfirmed = added?.ok && Array.isArray(added.body?.items) &&
          Array.from(requested.keys()).every(id => added.body.items.some(item => String(item.variant_id ?? item.id) === id));

        if (complete && responseConfirmed) {
          this.say('Deine Auswahl ist im Warenkorb. Der Warenkorb wird geöffnet …');
          location.assign(this.cartURL.href);
          return;
        }

        this.say(after
          ? 'Die Hinzufügung wurde nicht vollständig bestätigt. Bitte den Warenkorb prüfen: Es können bereits Artikel enthalten sein. Es wurde kein zweiter Versuch gesendet.'
          : 'Die Hinzufügung konnte nicht überprüft werden. Bitte den Warenkorb öffnen, bevor du erneut bestellst. Es wurde kein zweiter Versuch gesendet.', true);
        if (sameCart) {
          this.result.hidden = false;
          requested.forEach(item => {
            const delta = this.quantity(after, item.id) - this.quantity(before, item.id);
            const line = document.createElement('li');
            line.textContent = item.label + ': ausgewählt ' + item.quantity + '; Änderung im Warenkorb ' + (delta >= 0 ? '+' : '') + delta + '.';
            this.result.append(line);
          });
        }
      }
    }
    customElements.define('mocolune-pair-builder', MocolunePairBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
